module.exports = __webpack_public_path__ + "img/1-2.68282e42.svg";